import { subscribeAllBuddyMailAttachments } from '../api/attachment.js';
import { TrMailEditor } from '@adornis/bh-mail-editor/client/tr-mail-editor.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { xComponents } from '@adornis/chemistry/elements/x-components.js';
import '@adornis/popover/x-dropdown-multiselection.js';
import '@adornis/writer/x-tinymce.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/**
 * @element matching-mail-editor
 */
@customElement('matching-mail-editor')
export class TrBuddyMailEditor extends TrMailEditor {
  @state() private readonly buddyAttachments = new RXController(
    this,
    subscribeAllBuddyMailAttachments()({ _id: 1, meta: { fileName: 1 } }),
  );

  // Dummy Values for EmailPreview...
  override async getVariableValues() {
    if (!this.value.value) return {};
    const superVarValues = await super.getVariableValues();

    return {
      ...superVarValues,
      // TODO: add test variable data
    };
  }

  protected override writerContent() {
    return xComponents(html`
      <x-flex space="md" flex>
        <x-h3> Nachricht </x-h3>
        <x-input ${this._form.field('subject')} placeholder="Betreff"></x-input>
        <x-tinymce
          flex
          placeholder="Hier E-Mail Text eingeben.."
          .editorOptions=${this.editorOptions}
          ${this._form.field('content')}
        ></x-tinymce>
      </x-flex>
    `);
  }

  override render() {
    return html`
      <tr-flex space="lg" flex h100>
        ${this.variablesDisplay()}
        <tr-flex horizontal space="md" wrap flex> ${this.editorContent()} ${this.previewContent()} </tr-flex>
        ${this.attachments ? this.attachmentSection() : nothing}
        <tr-flex start horizontal space="md">
          ${this.saveButton()} ${this.deleteButton()} ${this._copyFromGlobal()}
        </tr-flex>
      </tr-flex>
    `;
  }

  override attachmentSection() {
    return html`
      <x-dropdown-multiselection
        .selectables=${this.buddyAttachments?.value ?? []}
        .renderString=${attachment => attachment.meta?.fileName}
        placeholder="Anhänge"
        placeholder-mode="inline-floating"
        .value=${(this.buddyAttachments?.value ?? []).filter(file =>
          this._form.document?.activatedAttachments.includes(file._id),
        )}
        @value-picked=${e => (this._form.document!.activatedAttachments = e.detail.value?.map(file => file._id) ?? [])}
      ></x-dropdown-multiselection>
    `;
  }
}
